import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LogoIcon from '~/icons/components/LogoIcon';
import Logo from '~/shared/components/Logo';
import { Link } from '~/techstyle-shared/next-routes';
import {
  mobile,
  useBreakpoint,
  useTheme,
} from '~/techstyle-shared/react-components';

const ListItem = styled.li`
  text-align: center;
  display: flex;
  height: 100%;
  border-right: 1px solid ${({ theme }) => theme.colors.metaNavListItemBorder};
  flex-basis: ${({ $brand }) => ($brand === 'fabletics' ? '135px' : '100px')};

  ${({ theme, $isActive }) => `
    background-color: ${
      $isActive ? theme.colors.metaNavListItemBg : 'transparent'
    };
  `}

  &:hover {
    ${({ theme, $isActive }) =>
      !$isActive && theme.builderHeader.metaNavItem.hover};
  }

  & > a {
    padding: 0;
  }

  ${mobile`
    ${({ theme, $isActive }) => `
      background-color: ${
        $isActive ? theme.colors.mobileMetaNavListItemBg : 'transparent'
      };
      border-bottom: 4px solid ${
        $isActive
          ? theme.colors.palette.black
          : theme.colors.mobileMetaNavListItemBorder
      };
      border-right: none;
      flex: 1 0 auto;
    `}
  `}
`;

const StyledAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 24px;

  & svg {
    height: ${({ $brand }) => ($brand === 'fabletics' ? '12px' : '19px')};
    width: auto;
    fill: ${({ $fill }) => $fill};

    ${mobile`
      height: ${({ $brand }) => ($brand === 'fabletics' ? '22px' : '19px')};
    `}
  }
`;

const MetaNavItem = ({ item, isActiveBrand }) => {
  const { brand, href } = item;

  const router = useRouter();
  const { white, shadow } = useTheme().colors.palette;
  const { isMobile } = useBreakpoint();

  const Component = isMobile ? LogoIcon : Logo;

  const handleClick = (e) => {
    e.preventDefault();
    const url = new URL(href, window.location.origin);
    router.push(url.toString());
  };

  return (
    <ListItem
      onClick={handleClick}
      $isActive={isActiveBrand}
      data-autotag={`metanav-${brand}`}
      $brand={brand}
    >
      <Link href={href} passHref>
        <StyledAnchor $brand={brand} $fill={isActiveBrand ? white : shadow}>
          <Component
            brandName={brand}
            color={isActiveBrand ? white : shadow}
            href={href}
          />
        </StyledAnchor>
      </Link>
    </ListItem>
  );
};

MetaNavItem.propTypes = {
  isActiveBrand: PropTypes.bool,
  item: PropTypes.shape({
    brand: PropTypes.string,
    href: PropTypes.string,
    exclusiveDomainList: PropTypes.arrayOf(PropTypes.string),
    isSecondarySite: PropTypes.bool,
  }),
};

export default MetaNavItem;
